export default function FinalCTA() {
  return (
    <section className="py-24 lg:py-32 bg-[#0F1F3D] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#4DB8D4] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#4DB8D4] rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <span className="text-xs font-semibold tracking-widest uppercase text-[#4DB8D4] mb-6 block">
          Join the Waitlist
        </span>

        <h2 className="text-4xl lg:text-6xl font-serif text-white leading-tight mb-6">
          <span className="block">The Platform for Modern</span>
          <span className="block">Veterinary Care & Commerce</span>
        </h2>

        <p className="text-xl text-[#A8C8D8] mb-10 max-w-2xl mx-auto">
          Own your practice infrastructure. Build recurring revenue. Stay compliant. All on one platform.
        </p>

        {/* CTA with animations */}
        <div className="relative inline-block mb-6">
          {/* Floating urgency badge */}
          <div className="absolute -top-3 -right-3 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg animate-bounce z-10">
            <span className="flex items-center gap-1">
              <i className="ri-fire-fill"></i>
              Act now
            </span>
          </div>

          {/* Pulsing glow rings */}
          <div className="absolute inset-0 rounded-full bg-[#4DB8D4] opacity-75 animate-ping"></div>
          <div className="absolute inset-0 rounded-full bg-[#4DB8D4] opacity-50 blur-xl animate-pulse"></div>

          {/* Main button */}
          <button className="relative px-10 py-5 bg-[#4DB8D4] text-white text-lg font-semibold rounded-full hover:bg-[#3aa8c4] transition-all inline-flex items-center gap-3 whitespace-nowrap cursor-pointer group shadow-lg shadow-[#4DB8D4]/30 hover:shadow-[#4DB8D4]/50 hover:scale-105">
            Request Invitation
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-2 transition-transform duration-300"></i>
          </button>
        </div>

        <p className="text-sm text-[#7DCFE8]">
          No credit card required • Early access is free
        </p>

        {/* Stats */}
        <div className="grid md:grid-cols-3 gap-8 mt-16 pt-16 border-t border-white/10">
          <div>
            <p className="text-4xl font-bold text-white mb-2">200+</p>
            <p className="text-[#A8C8D8]">Veterinarians signed up</p>
          </div>
          <div>
            <p className="text-4xl font-bold text-white mb-2">$15.5K<sup className="text-xl">*</sup></p>
            <p className="text-[#A8C8D8]">Potential Recurring Monthly Revenue</p>
            <p className="text-xs text-[#7DCFE8] mt-2 italic">
              *Illustrative scenario: 40 teleconsults/mo @ $150 avg + 80 memberships @ $25/mo + 50 subscription care plans @ $30/mo + product margins. Actual earnings depend on service mix, pricing, patient volume, and time commitment. Individual results will vary.
            </p>
          </div>
          <div>
            <p className="text-4xl font-bold text-white mb-2">4.9★</p>
            <p className="text-[#A8C8D8]">Early Access Rating</p>
          </div>
        </div>

        {/* Feature bullets */}
        <div className="mt-12 pt-10 border-t border-white/10">
          <p className="text-sm font-semibold tracking-widest uppercase text-[#4DB8D4] mb-6">
            Built for employed, relief, and independent veterinarians
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            {[
              { icon: 'ri-hospital-line', text: 'No clinic required' },
              { icon: 'ri-timer-flash-line', text: 'Set up in minutes' },
              { icon: 'ri-calendar-check-line', text: 'Flexible around your schedule' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2.5 bg-white/8 border border-white/15 px-5 py-3 rounded-full">
                <i className={`${item.icon} text-[#4DB8D4] text-base`}></i>
                <span className="text-sm text-white/90 whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes ping {
          75%, 100% {
            transform: scale(1.15);
            opacity: 0;
          }
        }
        @keyframes pulse {
          0%, 100% {
            opacity: 0.5;
          }
          50% {
            opacity: 0.3;
          }
        }
        @keyframes bounce {
          0%, 100% {
            transform: translateY(-5%);
            animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
          }
          50% {
            transform: translateY(0);
            animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
          }
        }
        .animate-ping {
          animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
        }
        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
        .animate-bounce {
          animation: bounce 1s infinite;
        }
      `}</style>
    </section>
  );
}